/* AMP selections + the native bundle's single cart request.
 * _amp_u matches AMP embedded-product.js's metadata encoding. Review this
 * adapter if AMP changes EMBEDDED_PRODUCT_SELECTIONS or its discount format.
 */
(() => {
  if (window.UpliefAmpAddon) return;
  const rootSelector = '#amp-embedded-product-upsell';
  const checkboxSelector = '.amp-embedded-product-upsells__upsell-item-checkbox';
  const targetHandles = {
    'premium-bamboo-gloves': 'premium-bamboo-knee-sleeves',
    'premium-bamboo-knee-sleeves': 'premium-bamboo-gloves',
    'premium-anti-fatigue-bamboo-footsleeves': 'premium-bamboo-knee-sleeves',
    'premium-bamboo-compression-socks': 'premium-bamboo-knee-sleeves',
    'premium-bamboo-leg-sleeves': 'premium-bamboo-knee-sleeves'
  };
  const sourceHandle = location.pathname.match(/^\/products\/([^/]+)/)?.[1];
  const targetHandle = targetHandles[sourceHandle];
  let targetProduct;
  let targetRequest;
  const style = document.createElement('style');
  style.textContent = `
    #amp-embedded-product-upsell .amp-embedded-product-upsells__header-title { font-size: 18px !important; line-height: 1.35 !important; font-weight: 750 !important; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item { display: grid !important; grid-template-columns: 30px 110px minmax(0, 1fr); gap: 12px !important; align-items: center; padding: 16px !important; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item > div:first-child { display: flex; align-items: center; justify-content: center; min-width: 0; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-container { width: 110px; min-width: 0; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-image { display: block; width: 110px !important; height: 110px !important; max-width: 100% !important; max-height: none !important; object-fit: cover; border-radius: 9px; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-title { font-size: 19px !important; line-height: 1.3 !important; font-weight: 750 !important; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-price { flex-wrap: wrap; column-gap: 9px !important; row-gap: 3px !important; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-price--discounted { font-size: 19px !important; line-height: 1.3 !important; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-price--original { font-size: 17px !important; line-height: 1.3 !important; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-checkbox { width: 28px !important; height: 28px !important; margin: 0 !important; cursor: pointer; }
    #amp-embedded-product-upsell .uplief-amp-variants[hidden] { display: none !important; }
    #amp-embedded-product-upsell .uplief-amp-variants { display: block; width: 100%; min-width: 0; margin-top: 14px; box-sizing: border-box; }
    #amp-embedded-product-upsell .uplief-amp-variants label { display: block; min-width: 0; color: #212121; font-size: 16px; font-weight: 700; }
    #amp-embedded-product-upsell .uplief-amp-variants select { display: block; width: 100%; max-width: 100%; min-width: 0; min-height: 52px; margin-top: 6px; padding: 9px 12px; box-sizing: border-box; border: 1px solid #aaa; border-radius: 6px; background: #fff; color: #212121; font: inherit; font-size: 18px; }
    #amp-embedded-product-upsell .uplief-amp-variants select:focus-visible { outline: 2px solid #fa5b00; outline-offset: 2px; }
    #amp-embedded-product-upsell .uplief-amp-variants select { display: none !important; }
    #amp-embedded-product-upsell .uplief-amp-variant-trigger, #amp-embedded-product-upsell .uplief-amp-variant-choice { box-sizing: border-box; min-height: 48px; padding: 9px 12px; border: 1px solid #aaa !important; border-radius: 6px; background: #fff !important; color: #212121 !important; font: inherit; font-size: 16px; text-align: left; touch-action: manipulation; -webkit-tap-highlight-color: transparent; }
    #amp-embedded-product-upsell .uplief-amp-variant-trigger { display: flex; align-items: center; justify-content: space-between; gap: 12px; width: 100%; margin-top: 6px; }
    #amp-embedded-product-upsell .uplief-amp-variant-trigger:after { content: "⌄"; font-size: 21px; line-height: 1; }
    #amp-embedded-product-upsell .uplief-amp-variant-menu { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 6px; margin-top: 6px; }
    #amp-embedded-product-upsell .uplief-amp-variant-menu[hidden] { display: none !important; }
    #amp-embedded-product-upsell .uplief-amp-variant-choice[aria-current="true"] { border-color: #fa5b00 !important; background: #fff1e8 !important; }
    #amp-embedded-product-upsell .uplief-amp-variant-trigger:focus-visible, #amp-embedded-product-upsell .uplief-amp-variant-choice:focus-visible { outline: 2px solid #fa5b00; outline-offset: 2px; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-details { min-width: 0; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item { border: 1px solid #ffc8aa !important; border-radius: 12px; background: #fffaf7 !important; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-checkbox { appearance: none !important; -webkit-appearance: none !important; display: block; flex: none; border: 2px solid #858585 !important; border-radius: 50% !important; background: #fff !important; box-shadow: none !important; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-checkbox:checked { border-color: #fa5b00 !important; background: #fa5b00 !important; box-shadow: inset 0 0 0 5px #fff !important; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-checkbox:focus-visible { outline: 2px solid #fa5b00; outline-offset: 3px; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-price--discounted { color: #e65300 !important; font-weight: 800 !important; }
    #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-price--discount { display: inline-flex; align-items: center; max-width: 100%; min-height: 29px; margin-top: 3px; padding: 6px 11px; border: 0 !important; border-radius: 999px; background: #e65300 !important; color: #fff !important; font-size: 15px !important; font-weight: 800; letter-spacing: .02em; line-height: 1.2; text-transform: uppercase; box-shadow: 0 2px 7px #e6530038; white-space: nowrap; }
    @media (max-width: 749px) {
      #amp-embedded-product-upsell .amp-embedded-product-upsells__header-title { font-size: 16px !important; }
      #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item { grid-template-columns: 28px 96px minmax(0, 1fr); gap: 10px !important; padding: 14px !important; }
      #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-container { width: 96px; }
      #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-image { width: 96px !important; height: 96px !important; }
      #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-title { font-size: 18px !important; }
      #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-price--discounted { font-size: 18px !important; }
      #amp-embedded-product-upsell .uplief-amp-variants select,
      #amp-embedded-product-upsell .uplief-amp-variants select option { font-size: 16px !important; font-weight: 400 !important; }
    }
    @media (max-width: 359px) {
      #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item { grid-template-columns: 26px 86px minmax(0, 1fr); gap: 8px !important; padding: 11px !important; }
      #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-container { width: 86px; }
      #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-image { width: 86px !important; height: 86px !important; }
      #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-title { font-size: 17px !important; }
      #amp-embedded-product-upsell .amp-embedded-product-upsells__upsell-item-checkbox { width: 26px !important; height: 26px !important; }
    }
  `;
  document.head.append(style);
  function getProduct() {
    if (targetProduct) return Promise.resolve(targetProduct);
    if (!targetRequest) targetRequest = fetch(`/products/${targetHandle}.js`)
      .then(response => {
        if (!response.ok) throw new Error('Unable to load complementary sizes.');
        return response.json();
      })
      .then(product => {
        targetProduct = product;
        return product;
      })
      .catch(error => {
        targetRequest = null;
        throw error;
      });
    return targetRequest;
  }
  function addOption(select, value, label) {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = label;
    select.append(option);
  }
  function renderVariantPicker(item, checkbox, product) {
    if (item.querySelector('.uplief-amp-variants')) return;
    const variants = product.variants.filter(variant => variant.available);
    const container = document.createElement('div');
    container.className = 'uplief-amp-variants';
    container.hidden = !checkbox.checked;
    const label = document.createElement('label');
    label.textContent = 'Choose colour and size';
    const select = document.createElement('select');
    select.className = 'amp-embedded-product-upsells__upsell-item-variant-selector';
    select.setAttribute('aria-label', 'Complementary pair variant');
    variants.forEach(variant => addOption(select, String(variant.id), variant.title));
    select.value = String(variants[0]?.id || '');
    label.append(select);
    container.append(label);
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'uplief-amp-variant-trigger';
    trigger.setAttribute('aria-label', 'Choose complementary pair colour and size');
    trigger.setAttribute('aria-expanded', 'false');
    const menu = document.createElement('div');
    menu.className = 'uplief-amp-variant-menu';
    menu.hidden = true;
    for (const variant of variants) {
      const choice = document.createElement('button');
      choice.type = 'button';
      choice.className = 'uplief-amp-variant-choice';
      choice.textContent = variant.title;
      choice.setAttribute('aria-current', String(variant.id) === select.value ? 'true' : 'false');
      choice.addEventListener('click', event => {
        event.stopPropagation();
        select.value = String(variant.id);
        trigger.textContent = variant.title;
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        menu.querySelectorAll('.uplief-amp-variant-choice').forEach(button =>
          button.setAttribute('aria-current', String(button.textContent) === variant.title ? 'true' : 'false'));
        select.dispatchEvent(new Event('change', {bubbles:true}));
      });
      menu.append(choice);
    }
    trigger.textContent = variants[0]?.title || 'Choose colour and size';
    trigger.addEventListener('click', event => {
      event.stopPropagation();
      menu.hidden = !menu.hidden;
      trigger.setAttribute('aria-expanded', String(!menu.hidden));
    });
    container.append(trigger, menu);
    function updateSelection() {
      const variant = variants.find(candidate => String(candidate.id) === select.value);
      container.dataset.variantId = variant ? String(variant.id) : '';
      const image = item.querySelector('.amp-embedded-product-upsells__upsell-item-image');
      const imageUrl = variant?.featured_image?.src || product.featured_image;
      if (image && imageUrl && variant) {
        image.src = imageUrl;
        image.alt = `${product.title} — ${variant.title}`;
      }
      const selection = window.AMP_API?.EMBEDDED_PRODUCT_SELECTIONS?.[0];
      if (variant && selection && window.AMP_API.EMBEDDED_PRODUCT_SELECTIONS.length === 1) {
        selection.variantId = `gid://shopify/ProductVariant/${variant.id}`;
      }
    }
    select.addEventListener('change', updateSelection);
    select.addEventListener('change', updateSavings);
    checkbox.addEventListener('change', () => {
      container.hidden = !checkbox.checked;
      if (checkbox.checked) {
        updateSelection();
        setTimeout(updateSelection, 0);
      }
    });
    item.querySelector('.amp-embedded-product-upsells__upsell-item-details')?.append(container);
    updateSelection();
    updateSavings();
  }
  function updateSavings() {
    document.querySelector('uplief-native-bundles')?.renderTotalSavings?.();
  }
  function rootFor(form) {
    const root = document.querySelector(rootSelector);
    return root && form?.contains(root) ? root : null;
  }
  function placeOffer() {
    const bundle = document.querySelector('uplief-native-bundles');
    const form = bundle?.closest('form');
    const buttons = form?.querySelector('.product-form__buttons');
    const root = document.querySelector(rootSelector);
    // AMP renders prices with the currency code (for example, "SGD 29.00").
    // Match the store's bundle price presentation while leaving Shopify's
    // underlying SGD amounts and checkout currency untouched.
    root?.querySelectorAll('.amp-embedded-product-upsells__upsell-item-price--discounted, .amp-embedded-product-upsells__upsell-item-price--original').forEach(price => {
      const current = price.textContent;
      const formatted = current.replace(/^SGD\s*/i, '$');
      if (formatted !== current) price.textContent = formatted;
    });
    const wrapper = root?.closest('.shopify-app-block');
    if (wrapper && buttons && (wrapper.parentElement !== buttons.parentElement ||
        !(wrapper.compareDocumentPosition(buttons) & Node.DOCUMENT_POSITION_FOLLOWING))) {
      buttons.before(wrapper);
      wrapper.style.marginBottom = '16px';
    }
    const summary = bundle?.totalSavingsSummary || bundle?.querySelector('[data-ub-total-savings]');
    if (summary && buttons) {
      bundle.totalSavingsSummary = summary;
      let needsUpdate = false;
      const total = summary.querySelector('[data-uplief-order-total]');
      if (total) {
        total.remove();
        needsUpdate = true;
      }
      if (summary.nextElementSibling !== buttons) {
        buttons.before(summary);
        needsUpdate = true;
      }
      if (needsUpdate) updateSavings();
    }
    root?.querySelectorAll(checkboxSelector).forEach(checkbox => {
      checkbox.setAttribute('aria-label', 'Add the complementary pair at 50% off');
      if (!checkbox.dataset.upliefPriceListener) {
        checkbox.dataset.upliefPriceListener = 'true';
        checkbox.addEventListener('change', updateSavings);
      }
      const item = checkbox.closest('.amp-embedded-product-upsells__upsell-item');
      if (targetHandle && item && !item.querySelector('.uplief-amp-variants') && !item.dataset.upliefVariantsLoading) {
        item.dataset.upliefVariantsLoading = 'true';
        getProduct()
          .then(product => renderVariantPicker(item, checkbox, product))
          .catch(error => {
            item.dataset.upliefVariantsLoading = '';
            item.setAttribute('data-uplief-variant-error', error.message);
          });
      }
    });
    root?.querySelectorAll('.amp-embedded-product-upsells__upsell-item-variant-selector').forEach(select => {
      select.setAttribute('aria-label', 'Complementary pair size and style');
    });
  }
  window.UpliefAmpAddon = {
    getOfferPricing(form) {
      const root = rootFor(form);
      const checked = root?.querySelector(`${checkboxSelector}:checked`);
      if (!checked || !targetProduct) return {priceCents:0,savingsCents:0};
      const item = checked.closest('.amp-embedded-product-upsells__upsell-item');
      const selectedId = item?.querySelector('.uplief-amp-variants select')?.value;
      const variant = targetProduct.variants.find(candidate => candidate.available && String(candidate.id) === selectedId) ||
        targetProduct.variants.find(candidate => candidate.available);
      if (!variant) return {priceCents:0,savingsCents:0};
      const original = Number(variant.price);
      const priceCents = Math.round(original / 2);
      return {priceCents,savingsCents:original-priceCents};
    },
    getSelectedItem(form) {
      const root = rootFor(form);
      const checked = root?.querySelectorAll(`${checkboxSelector}:checked`);
      if (!checked?.length) return null;
      if (checked.length !== 1) throw new Error('Please select one complementary pair.');
      const item = checked[0].closest('.amp-embedded-product-upsells__upsell-item');
      const picker = item?.querySelector('.uplief-amp-variants');
      const selections = window.AMP_API?.EMBEDDED_PRODUCT_SELECTIONS;
      const selection = Array.isArray(selections) && selections.length === 1 ? selections[0] : null;
      const variant = String(selection?.variantId || '');
      const id = variant.split('/').pop();
      const metadata = selection?.analyticsMetadata;
      const discount = selection?.discount;
      if (picker && !picker.hidden && !picker.dataset.variantId) {
        throw new Error('Choose the complementary pair colour and size before adding to cart.');
      }
      // Fail before either item is added if AMP has not supplied a matching offer.
      if (!picker || picker.hidden || !picker.dataset.variantId ||
          !selection || !/^\d+$/.test(id) || picker.dataset.variantId !== id ||
          Number(selection.quantity) !== 1 ||
          Number(discount?.value) !== 50 || !String(discount?.type || '').startsWith('p') ||
          !metadata?.offerId || !metadata?.offerItemId) {
        throw new Error('The complementary offer is still updating. Please reselect its size and try again.');
      }
      const attribution = {
        t: 'Em',
        m: { c: metadata.campaignId, o: metadata.offerId, oi: metadata.offerItemId, e: metadata.experimentId },
        d: { v: discount.value, t: discount.type.charAt(0) }
      };
      const bytes = new TextEncoder().encode(JSON.stringify(attribution));
      const encoded = btoa(Array.from(bytes, byte => String.fromCharCode(byte)).join(''));
      return {
        id,
        quantity: 1,
        properties: {
          _amp_u: encoded,
          _uplief_addon_source: sourceHandle
        }
      };
    },
    clearSelection(form) {
      rootFor(form)?.querySelectorAll(`${checkboxSelector}:checked`).forEach(checkbox => checkbox.click());
      if (window.AMP_API) window.AMP_API.EMBEDDED_PRODUCT_SELECTIONS = [];
    }
  };
  let observer;
  const start = () => {
    observer?.disconnect();
    placeOffer();
    const root = document.querySelector(rootSelector);
    if (root) {
      observer = new MutationObserver(placeOffer);
      observer.observe(root, { childList: true, subtree: true });
      return;
    }
    observer = new MutationObserver(() => {
      if (!document.querySelector(rootSelector)) return;
      start();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };
  start();
  window.addEventListener('pagehide', () => observer?.disconnect());
  window.addEventListener('pageshow', start);
})();
